import moment from "moment";
import Datepicker from "react-tailwindcss-datepicker";
import { SearchIcon } from "@heroicons/react/outline";
import Button from "components/button";
import { Label } from "components/label";
import Input from "components/input";
import Select from "components/select";
import { twMerge } from "tailwind-merge";

export interface FilterType {
  page: number;
  q: string;
  created_by: string;
  from_date: string;
  to_date: string;
}

export const CREATED_BY_OPTIONS = [
  { value: "", label: "All" },
  { value: "user", label: "User" },
  { value: "system", label: "System" },
];

interface PropType {
  filter: FilterType;
  handleChangeFilter: (key: string, value: string, value2?: string) => void;
  onSubmit: (data: FilterType) => void;
}

const FilterBar = (props: PropType) => {
  const { filter, handleChangeFilter, onSubmit } = props;

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    onSubmit(filter);
  };

  return (
    <form
      className="box-container w-full flex flex-wrap items-end gap-3"
      onSubmit={(e) => {
        handleSubmit(e);
      }}
    >
      <div className="w-full md:w-[400px]">
        <Label id="search" name="Search" />
        <div className="mt-2">
          <Input
            className="px-2 py-2"
            label="Search"
            id="search"
            type="text"
            placeholder="Search by Full Name, Email, Phone"
            value={filter.q}
            onChange={(e: any) => {
              handleChangeFilter("q", e.target.value);
            }}
          />
        </div>
      </div>

      <div className="w-[200px]">
        <Label id="created_by" name="Created By" />
        <div className="mt-2">
          <Select
            options={CREATED_BY_OPTIONS}
            isClearable={true}
            id="created_by"
            placeholder="Select option"
            className="py-0.5"
            value={CREATED_BY_OPTIONS.find(
              (d) => d.value === filter.created_by
            )}
            onChange={(selected: { label: string; value: string }) => {
              handleChangeFilter("created_by", selected?.value ?? "");
            }}
          />
        </div>
      </div>

      <div className="w-[300px]">
        <Label id="created_at" name="Created At" />
        <div className="mt-2">
          <Datepicker
            value={{
              startDate: filter.from_date,
              endDate: filter.to_date,
            }}
            onChange={(value) => {
              handleChangeFilter(
                "created_at",
                value?.startDate
                  ? moment(value?.startDate).format("YYYY-MM-DD")
                  : "",
                value?.endDate
                  ? moment(value?.endDate).format("YYYY-MM-DD")
                  : ""
              );
            }}
            displayFormat="DD/MM/YYYY"
            placeholder="Start date - End date"
            inputClassName="date-picker"
            popoverDirection="down"
            containerClassName={(className) => twMerge(className, "date-picker-container")}
          />
        </div>
      </div>

      <Button
        type="submit"
        className="w-[100px] bg-white rounded-md px-3 text-brand-500 py-2
                        border-solid border-brand-500 border-[1px] hover:bg-white active:bg-white active:opacity-85"
      >
        <SearchIcon className="w-3 h-4 text-brand-500 mr-2" /> Search
      </Button>
    </form>
  );
};

export default FilterBar;
